import { render, staticRenderFns } from "./dashboardStat.vue?vue&type=template&id=5cbffb48&scoped=true"
import script from "./dashboardStat.vue?vue&type=script&lang=js"
export * from "./dashboardStat.vue?vue&type=script&lang=js"
import style0 from "./dashboardStat.vue?vue&type=style&index=0&id=5cbffb48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbffb48",
  null
  
)

export default component.exports